export const TAX_LOCATION_ACCESS_GRACE_PERIOD_MS = 7 * 24 * 60 * 60 * 1000;

function timestampToMillis(value) {
  if (!value) return null;

  const date = value?.toDate
    ? value.toDate()
    : value?._seconds
      ? new Date(value._seconds * 1000)
      : new Date(value);
  const millis = date.getTime();

  return Number.isFinite(millis) ? millis : null;
}

/**
 * Tax-location failures leave Stripe subscriptions active while their renewal
 * invoices remain unpaid. Give newly affected users time to fix their billing
 * address, then fail closed. Legacy flags without a detection timestamp are
 * blocked immediately so malformed/backfilled records cannot bypass the gate.
 */
export function hasTaxLocationAccessBlock({
  taxLocationIssue,
  taxLocationIssueDetectedAt,
  paused,
  now = Date.now(),
}) {
  if (!taxLocationIssue || paused) return false;

  const detectedAt = timestampToMillis(taxLocationIssueDetectedAt);
  if (detectedAt === null) return true;

  return now - detectedAt >= TAX_LOCATION_ACCESS_GRACE_PERIOD_MS;
}
